import { all, call } from 'redux-saga/effects';
import facebookSaga from './handlers/facebookHandlers';


export default function* rootSaga() {
    yield all([
        call(facebookSaga)
    ]);
}
